import { SETTING_CONSTANTS } from '../NRSettings.contants';

export const SETTINGS_INTEGRATIONS_PATH = `/settings/${SETTING_CONSTANTS.TABS.INTEGRATIONS}`;

export const INTEGRATIONS_PAGE_LABELS = {
  AVAILABLE_INTEGRATIONS_TITLE: 'Available Integrations'
};

export const INTEGRATION_CATEGORY_TITLES = {
  TICKETING: 'Ticketing & Messaging'
};
